export const formDataToObject = (
  formData: FormData,
  excludedKeys?: string[],
): Record<string, string | File> => {
  const result: Record<string, string | File> = {};
  for (const [key, value] of formData.entries()) {
    if (!excludedKeys?.includes(key)) {
      result[key] = value;
    }
  }
  return result;
};

export const createDescription = (formData: FormData) => {
  let description = '';
  const productNameValue = formData.get('product_name') as string;
  const descriptionValue = formData.get('description') as string;

  if (productNameValue && productNameValue.length > 0) {
    description = description.concat(`Product: ${productNameValue}\n\n`);
  }

  description = description.concat(`Description:\n${descriptionValue}`);

  return description;
};
